"use client";

import { c as _c } from "react/compiler-runtime";
import { Suspense } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { RegistrarLinks, RegistrarLinksSkeleton } from "@/components/domain/registrar-links";
import { NONPUBLIC_TLDS } from "@domainstack/constants";
import { extractTldClient } from "@domainstack/utils/domain/client";
interface DomainUnregisteredCardProps {
  domain: string;
}
export function DomainUnregisteredCard(t0) {
  const $ = _c(18);
  const {
    domain
  } = t0;
  const t1 = domain ?? "";
  let t2;
  if ($[0] !== t1) {
    const lower = t1.toLowerCase();
    t2 = NONPUBLIC_TLDS.some(suffix => lower.endsWith(suffix));
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const isNonPublicTld = t2;
  let t3;
  if ($[2] !== domain) {
    t3 = extractTldClient(domain);
    $[2] = domain;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const tld = t3;
  const canShowRegistrarLinks = !isNonPublicTld && tld;
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      "--glow-color": "var(--accent-indigo)"
    };
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div aria-hidden={true} className="pointer-events-none absolute -inset-x-16 -top-16 h-40 accent-glow opacity-40 blur-3xl" style={t4 as React.CSSProperties} />;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== domain) {
    t6 = <h2 className="text-2xl font-semibold tracking-tight sm:text-3xl">{domain}</h2>;
    $[6] = domain;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <p className="mt-2 text-sm text-muted-foreground sm:text-base">appears to be unregistered…</p>;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== t6) {
    t8 = <div>{t6}{t7}</div>;
    $[9] = t6;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== canShowRegistrarLinks || $[12] !== domain || $[13] !== tld) {
    t9 = canShowRegistrarLinks && <ErrorBoundary fallback={null}><Suspense fallback={<RegistrarLinksSkeleton />}><RegistrarLinks domain={domain} tld={tld} /></Suspense></ErrorBoundary>;
    $[11] = canShowRegistrarLinks;
    $[12] = domain;
    $[13] = tld;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== t8 || $[16] !== t9) {
    t10 = <div className="relative overflow-hidden rounded-xl border border-black/10 bg-background/60 p-8 text-center shadow-2xl shadow-black/10 dark:border-white/10">{t5}<div className="space-y-4.5">{t8}{t9}</div></div>;
    $[15] = t8;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  return t10;
}